import { Observable, throwError } from 'rxjs';
import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../src/environments/environment';
import { tap, retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class FoodBudInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Check if request has 'X-Skip-Loader' header
    //  const skipLoader = req.headers.has('X-Skip-Loader');

    // Remove 'X-Skip-Loader' header before sending the request
    //  let modifiedReq = req;
    //  if (skipLoader) {
    //    modifiedReq = req.clone({
    //      headers: req.headers.delete('X-Skip-Loader'),
    //    });
    //  }


    const rentsherAuthToken = localStorage.getItem('access_token');
    let dateInMillis = new Date().getTime().toString();
    let headers = req.headers.set('Content-Type', 'application/json');
    if (req.url.includes("claimRestaurant")) {
      // console.log('works!!!!!')
      headers = req.headers
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      return next.handle(req.clone({ headers })).pipe(
        // retry(1),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
          } else if (error.status === 500) {
          } else {
            return throwError(error);
          }
        })
      );
    }

    if (req.url.includes("approveRestaurant") || req.url.includes('changeSuperAdminPassword')) {
      headers = req.
        headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      return next.handle(req.clone({ headers })).pipe(
        // retry(1),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
          } else if (error.status === 500) {
          } else {
            return throwError(error);
          }
        })
      );
    }

    if (rentsherAuthToken && this.payload(rentsherAuthToken)) {

      headers = req.headers
        .set('Authorization', 'Bearer ' + rentsherAuthToken)
        .set('Content-Type', 'application/json');
      if (req.url.includes("import-users")) {
        headers = req.headers
          .set('Authorization', 'Bearer ' + rentsherAuthToken);
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              // refresh token
              // this.handle401();
            } else if (error.status === 500) {
            } else {
              // this.handle401();
              return throwError(error);
            }
          })
        );
      }
      if (req.url.includes("uploadUserImage")) {
        //const headers = new Headers();
        /** In Angular 5, including the header Content-Type can invalidate your request */
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        //         headers = req.headers
        //   .set('Authorization','Bearer ' + rentsherAuthToken)
        //  .set('Content-Type', 'multipart/form-data')
        //   .set('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              // refresh token
              // this.handle401();
            } else if (error.status === 500) {
            } else {
              // this.handle401();
              return throwError(error);
            }
          })
        );
      }


      if (req.url.includes("dishUpload")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }
      if (req.url.includes("uploadDishImage")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }
      if (req.url.includes("updateRestaurant")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          // retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }
      if (req.url.includes("changeRestaurantPassword")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          // retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }
      if (req.url.includes("updateAdminProfile")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }
      if (req.url.includes("createCategory")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }
      if (req.url.includes("updateCategory")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }
      if (req.url.includes("updateAdminProfile")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }
      if (req.url.includes("createCuisine")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }
      if (req.url.includes("updateCuisine")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }
      if (req.url.includes("createRestaurant")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }

      if (req.url.includes("upload_restaurant_image")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }
      if (req.url.includes("uploadDishAudio")) {
        headers = req.
          headers.append('Authorization', 'Bearer ' + rentsherAuthToken)
        headers.append('Content-Type', 'audio/mpeg');
        headers.append('Accept', 'application/json');
        return next.handle(req.clone({ headers })).pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
            } else if (error.status === 500) {
            } else {
              return throwError(error);
            }
          })
        );
      }
      return next.handle(req.clone({ headers })).pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            localStorage.clear();
            this.router.navigate(['/public/resto']);
          } else if (error.status === 500) {
          } else {
            // this.handle401();
            return throwError(error);
          }
        })
      );
    } else {
      return next.handle(req.clone({ headers })).pipe(
        tap((err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
            }
            localStorage.clear();
            this.router.navigate(['/public/resto']);
          }
        })
      );
    }
  }

  redirect() {
    this.router.navigate(['/login'], { replaceUrl: true });
  }
  payload(rentsherAuthToken) {
    const jwtPayload = rentsherAuthToken.split('.')[1];
    let decodeToken = JSON.parse(atob(jwtPayload));
    return (Math.floor((new Date()).getTime() / 1000)) < decodeToken.exp;
  }

  // if (rentsherAuthToken) {
  //   headers = req.headers
  //     .set('Authorization','Bearer ' + rentsherAuthToken)
  //     .set('Content-Type', 'application/json');
  //   if(req.url.includes("import-users")){
  //     headers = req.headers
  //     .set('Authorization','Bearer ' + rentsherAuthToken);
  //     return next.handle(req.clone({ headers })).pipe(
  //       retry(1),
  //       catchError((error: HttpErrorResponse) => {
  //         if (error.status === 401) {
  //         } else if (error.status === 500) {
  //         } else {
  //           return throwError(error);
  //         }
  //       })
  //     );
  //   }
  //   if(req.url.includes("dishUpload")){
  //     headers = req.
  //     headers.append('Authorization','Bearer ' + rentsherAuthToken)
  //     headers.append('Content-Type', 'multipart/form-data');
  //     headers.append('Accept', 'application/json');
  //     return next.handle(req.clone({ headers })).pipe(
  //       retry(1),
  //       catchError((error: HttpErrorResponse) => {
  //         if (error.status === 401) {
  //         } else if (error.status === 500) {
  //         } else {
  //           return throwError(error);
  //         }
  //       })
  //     );
  //   }
  //   if(req.url.includes("uploadDishImage")){
  //     headers = req.
  //     headers.append('Authorization','Bearer ' + rentsherAuthToken)
  //     headers.append('Content-Type', 'multipart/form-data');
  //     headers.append('Accept', 'application/json');
  //     return next.handle(req.clone({ headers })).pipe(
  //       retry(1),
  //       catchError((error: HttpErrorResponse) => {
  //         if (error.status === 401) {
  //         } else if (error.status === 500) {
  //         } else {
  //           return throwError(error);
  //         }
  //       })
  //     );
  //   }

  //   if(req.url.includes("upload_restaurant_image")){
  //     headers = req.
  //     headers.append('Authorization','Bearer ' + rentsherAuthToken)
  //     headers.append('Content-Type', 'multipart/form-data');
  //     headers.append('Accept', 'application/json');
  //     return next.handle(req.clone({ headers })).pipe(
  //       retry(1),
  //       catchError((error: HttpErrorResponse) => {
  //         if (error.status === 401) {
  //         } else if (error.status === 500) {
  //         } else {
  //           return throwError(error);
  //         }
  //       })
  //     );
  //   }
  //   if(req.url.includes("uploadDishAudio")){
  //     headers = req.
  //     headers.append('Authorization','Bearer ' + rentsherAuthToken)
  //     headers.append('Content-Type', 'audio/mpeg');
  //     headers.append('Accept', 'application/json');
  //     return next.handle(req.clone({ headers })).pipe(
  //       retry(1),
  //       catchError((error: HttpErrorResponse) => {
  //         if (error.status === 401) {
  //         } else if (error.status === 500) {
  //         } else {
  //           return throwError(error);
  //         }
  //       })
  //     );
  //   }

  //   return next.handle(req.clone({ headers })).pipe(
  //     retry(1),
  //     catchError((error: HttpErrorResponse) => {
  //       if (error.status === 401) {
  //       } else if (error.status === 500) {
  //       } else {
  //         return throwError(error);
  //       }
  //     })
  //   );
  // } else {
  //   return next.handle(req.clone({ headers })).pipe(
  //     tap((err: any) => {
  //       if (err instanceof HttpErrorResponse) {
  //         if (err.status === 401) {
  //         }
  //       }
  //     })
  //   );
  // }



}
